import { configureStore, createListenerMiddleware } from '@reduxjs/toolkit';
import storage from 'redux-persist/lib/storage';
import {
    persistStore,
    FLUSH,
    REHYDRATE,
    PAUSE,
    PERSIST,
    PURGE,
    REGISTER,
} from 'redux-persist';
import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2';

import reducers from './reducers';

export const listenerMiddleware = createListenerMiddleware();

const persistConfig = {
    key: 'root',
    storage,
    stateReconciler: autoMergeLevel2,
};

export const store = configureStore({
    reducer: reducers,
    middleware: (getDefaultMiddleware) => {
        const middlewares = [];
        const defaultMiddleware = getDefaultMiddleware({
            serializableCheck: {
                winAfter: 128,
                ignoredActions: [
                    FLUSH,
                    REHYDRATE,
                    PAUSE,
                    PERSIST,
                    PURGE,
                    REGISTER,
                ],
            },
        })
            .prepend(listenerMiddleware.middleware)
            .concat(middlewares);
        return defaultMiddleware;
    },
});

export const startAppListening = listenerMiddleware.startListening;
export const stopAppListening = listenerMiddleware.stopListening;

export const persistor = persistStore(store);
